@use "../../sass/global/global" as *;

.ux-iws-tab-tags {
    padding: 10px 30px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 0 auto;
    position: relative;
    margin-bottom: 10px;
    max-width: 100%;

    &__tag {
        @include font(bold);
        font-size: 13px;
        text-transform: uppercase;
        height: 36px;
        margin-top: 5px;
        padding: 0 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: color $animationSpeed-fast $animationEasing-easeInOut;

        &:hover {
            color: $color-gray-70;
        }

        &.is-active {
            background-color: $color-blue-1;
            color: $color-white;
        }
    }

    &__anchor {
        position: absolute;
    }

    &--hidden {
        display: none;
    }
}
